<template>
    <div class="mb-4">
        {{ translate("Select Category") }}

        <select
            class="form-control"
            id="dm-select-category"
            v-model="submission.category_id"
            @change="resetTaxonomiesAndSave()"
        >
            <option value="" disabled>
                {{ translate("Select") }}
            </option>
            <option
                v-for="category in categories"
                :value="category.id"
                :key="'category-' + category.id"
                :disabled="!category.is_active"
            >
                {{ category.name }}
                <span v-if="!category.is_active">
                    - {{ translate("(Currently closed for intake)") }}</span
                >
            </option>
        </select>
    </div>
</template>

<script>
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapWritableState, mapActions } from "pinia";

export default {
    props: ["categories"],

    computed: {
        ...mapWritableState(useSubmissionWizardStore, ["submission"]),
    },

    methods: {
        ...mapActions(useSubmissionWizardStore, [
            "saveSubmissionAndReloadWizardContent",
        ]),

        // TODO: This should also update the Themes and sub_sub_categories, and other_genres
        resetTaxonomiesAndSave() {
            this.submission.sub_category_id = "";
            this.submission.sub_sub_category_id = "";
            this.submission.genres_ids = [];
            this.submission.other_genres = "";
            this.submission.editor_id = null; // Must always reset the editor, otherwise there might be conflicts.

            this.saveSubmissionAndReloadWizardContent();
        },
    },
};
</script>
